import GridPageAbstract from '../../../GridPageAbstract';
import { MenuItem } from '@mui/material';
import i18n from '../../../../i18';
import config from '../../../../config';
import { DriverLinearIcon } from '../../../../icons-lib';

export default class GridRolesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'roles';
        this.Server = this.props.context.getState().server.roles;

        this.Head = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text'
                // needTranslate: true
            },
            {
                id: 'systemRole',
                label: 'systemRole',
                alignRight: false,
                cell: 'Items',
                items: config.systemRoles.filter(
                    (role) => role !== 'merchant' && role !== 'user'
                )
            },
            {
                id: 'isDefault',
                label: 'isDefault',
                alignRight: false,
                cell: 'Checkbox',
                trueLabel: 'yes',
                falseLabel: 'no',
                type: 'boolean',
                filterCell: 'Boolean'
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                disableEditor: true
            }
        ];
    }

    renderCustomMenuItems = () => {
        const roleId = this.state.menuClickItemId;
        return (
            <>
                <MenuItem onClick={() => this.props.onRoleChange(roleId, 1)}>
                    <DriverLinearIcon sx={{ mr: 2 }} />
                    {i18n.t('buttons.editPermissions')}
                </MenuItem>
                <MenuItem onClick={() => this.props.onRoleChange(roleId, 2)}>
                    <DriverLinearIcon sx={{ mr: 2 }} />
                    {i18n.t('buttons.editActions')}
                </MenuItem>
            </>
        );
    };

    // isSystemRole = () => {
    //     const selectedRole = this.List.find((role) => role.id === this.state.menuClickItemId);
    //     return selectedRole?.systemRole;
    // };
}
